/**
 * @fileoverview HelpMenuItem — standard menu row inside the HelpPopover.
 * Thin wrapper over Blueprint's MenuItem with `shouldDismissPopover={true}`
 * (the Blueprint equivalent of `bp6-popover-dismiss` semantics) so any click
 * closes the popover and returns focus to the HelpButton trigger.
 *
 * Foundry mapping: a single `bp6-menu-item` row inside the help menu —
 * either a callback row (Ask AIP Assist, Contact support, About) or an
 * in-app link row (Training, Explore Examples, View support tickets).
 */

import { MenuItem } from "@blueprintjs/core";
import type { ReactElement } from "react";

export interface HelpMenuItemProps {
  label: string;
  /** A rendered icon element — e.g. `<Icon icon="learning" />` or
   *  `<AipLogoIcon />`. Typed as `ReactElement` to match Blueprint's
   *  `MaybeElement` shape for `MenuItem.icon`. */
  icon: ReactElement;
  onClick?: () => void;
  href?: string;
}

export function HelpMenuItem({ label, icon, onClick, href }: HelpMenuItemProps): ReactElement {
  return (
    <MenuItem data-testid="help-menu-item"
      text={label}
      icon={icon}
      onClick={onClick}
      href={href}
      shouldDismissPopover={true}
    />
  );
}
